/*
 * SoBeauty — подарунки в кошику (один скрипт на всі подарунки)
 *  • Спрей з колагеном — коли товарів на 1500 грн і більше.
 *  • Скраб SWEET JASMINE — коли в кошику є набір для росту волосся USMAN HERBAL.
 * Подарунки додаються одразу після першого товару (спрей другим, скраб за ним).
 * Замінює старі вбудовані скрипти подарунків у theme.liquid — їх треба видалити.
 */
(function () {
  'use strict';

  // ---------- Налаштування ----------
  var GIFTS = [
    { // Спрей — другим рядком
      variantId: 44610908586156,
      prop: '1',
      when: function (ctx) { return ctx.total >= 1500 * 100; }
    },
    { // Скраб — якщо є хоча б один із цих товарів (ID товару або варіанта)
      variantId: 45354096165036,
      prop: 'true',
      when: function (ctx) { return ctx.has([8586340794540]); }
    }
  ];
  var DELAY = 600; // мс: чекаємо, поки інші скрипти кошика закінчать
  // ----------------------------------

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var baseFetch = window.fetch.bind(window);
  // «Чистий» fetch із прихованого iframe: його запитів не бачать інші скрипти й додатки,
  // тому кошик не перемальовується на проміжних кроках.
  var silentFetch = (function () {
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      f.setAttribute('aria-hidden', 'true');
      document.documentElement.appendChild(f);
      return f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { return baseFetch; }
  })();
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var running = false;
  var again = false;
  var timer = null;

  function isGiftLine(i) { return !!(i.properties && i.properties._gift); }

  // Проміжні запити йдуть «тихо», щоб кошик не перемальовувався на кожному кроці
  // і не було видно, як товар зникає і з'являється.
  function api(path, body) {
    return silentFetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  function asAddLine(item) {
    var line = { id: item.variant_id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
    if (item.selling_plan_allocation) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
    return line;
  }

  // Запобіжник від зациклення: не більше 3 додавань подарунків за 20 секунд
  var stamps = [];
  function tooManyChanges() {
    var now = Date.now();
    stamps = stamps.filter(function (t) { return now - t < 20000; });
    if (stamps.length >= 3) return true;
    stamps.push(now);
    return false;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, DELAY);
  }

  async function sync() {
    if (running) { again = true; return; }
    running = true;
    var changed = false;

    try {
      var cart = await api('cart.js');
      var paid = cart.items.filter(function (i) { return !isGiftLine(i); });
      var ctx = {
        total: paid.reduce(function (s, i) { return s + i.final_line_price; }, 0),
        has: function (ids) {
          return paid.some(function (i) { return ids.indexOf(i.product_id) > -1 || ids.indexOf(i.variant_id) > -1; });
        }
      };

      var wanted = paid.length ? GIFTS.filter(function (g) { return g.when(ctx); }) : [];
      var giftLines = cart.items.filter(isGiftLine);
      var head = paid[0];

      // Подарунки, яких бракує
      var missing = wanted.filter(function (g) {
        return !giftLines.some(function (l) { return l.variant_id === g.variantId; });
      });

      // Зайві подарунки, дублікати, кількість не 1
      var seen = {};
      var fix = {};
      giftLines.forEach(function (l) {
        var need = wanted.some(function (g) { return g.variantId === l.variant_id; });
        if (!need || seen[l.variant_id]) fix[l.key] = 0;
        else if (l.quantity !== 1) fix[l.key] = 1;
        seen[l.variant_id] = true;
      });

      if (missing.length && tooManyChanges()) {
        console.warn('[gifts] забагато змін підряд — пауза');
      } else if (missing.length) {
        // Додаємо подарунки так, щоб вони стали одразу після першого товару:
        // прибираємо перший товар і наявні подарунки, потім додаємо одним запитом
        // у зворотному порядку (Shopify ставить новий рядок на початок кошика).
        // Порядок виставляється лише в цей момент — далі скрипт його не чіпає,
        // бо Shopify сам переставляє рядки зі знижками і «вирівнювання» зациклилося б.
        var updates = {};
        giftLines.forEach(function (l) { updates[l.key] = 0; });
        if (head) updates[head.key] = 0;
        await api('cart/update.js', { updates: updates });

        var items = wanted.map(function (g) {
          return { id: g.variantId, quantity: 1, properties: { _gift: g.prop } };
        }).reverse();
        if (head) items.push(asAddLine(head));
        try { await api('cart/add.js', { items: items }); }
        catch (e) {
          // Якщо подарунка немає в наявності — повертаємо хоча б товар клієнта
          if (head) await api('cart/add.js', { items: [asAddLine(head)] });
        }
        changed = true;
      } else if (Object.keys(fix).length) {
        await api('cart/update.js', { updates: fix });
        changed = true;
      }
    } catch (e) {
      console.warn('[gifts]', e);
    } finally {
      running = false;
      var recheck = changed || again;
      again = false;
      if (changed) await refreshUI();
      if (recheck && !changed) schedule();
    }
  }

  async function refreshUI() {
    // Один «порожній» запит через window.fetch: додаток кошика (Essential Cart Drawer
    // тощо) побачить його й оновить кошик один раз — уже з готовим результатом.
    try {
      await window.fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{}',
        credentials: 'same-origin'
      });
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var path = location.pathname.replace(root, '/');
    if (/^\/cart\/?$/.test(path)) { location.reload(); return; }

    // Вбудована шухляда теми (якщо використовується)
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var s = await baseFetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
      var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
      if (s['cart-drawer']) {
        var doc = parse(s['cart-drawer']);
        var fresh = doc.querySelector('#CartDrawer');
        var current = drawer.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var freshDrawer = doc.querySelector('cart-drawer');
        if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var b = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
    } catch (e) {
      console.warn('[gifts] refresh', e);
    }
  }

  // Будь-яка зміна кошика (тема, додатки) → перевірка через DELAY мс.
  // Власні зміни скрипта теж сюди потрапляють, але повторна перевірка нічого не змінює.
  window.fetch = function (input, init) {
    var url = input instanceof Request ? input.url : String(input);
    var p = baseFetch(input, init);
    if (CART_RE.test(url)) p.then(function () { if (!running) schedule(); else again = true; }).catch(function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', function () { if (!running) schedule(); else again = true; });
    return xhrOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();